import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BankStatement, BankStatementCreate, BankStatementFilter } from '../data/bankStatement';

export function createBankStatementService(client: AxiosInstance) {
  return createCrudService<BankStatement, BankStatementCreate, BankStatementFilter>(
    client,
    '/accounting/BankStatement',
    'id',
  );
}

export type BankStatementService = CrudService<BankStatement, BankStatementCreate, BankStatementFilter>;
